import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AuthCallback } from './components/auth-callback/auth-callback';
import { RouteAccessGuard } from './guard/route-access-guard';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },

      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./components/reports/reports.component').then(
            (m) => m.ReportsComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'dashboardCharts',
        loadComponent: () =>
          import('./components/dashboard-charts/dashboard-charts.component').then(
            (m) => m.DashboardChartsComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'changeTrackerReport',
        loadComponent: () =>
          import('./components/change-tracker-report/change-tracker-report.component').then(
            (m) => m.ChangeTrackerReportComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'addPosition',
        loadComponent: () =>
          import('./components/position-management/add-position/add-position').then(
            (m) => m.AddPosition,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'editPosition/:id',
        loadComponent: () =>
          import('./components/position-management/edit-position/edit-position').then(
            (m) => m.EditPosition,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'profile' },
      },
      {
        path: 'masterData',
        loadChildren: () =>
          import('../app/components/settings/master-data-management/master-data.routes').then(
            (r) => r.masterDataRoutes,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'appAdmin' },
      },
      {
        path: 'myProfile',
        loadComponent: () =>
          import('./components/settings/profile-settings/profile-settings.component').then(
            (m) => m.ProfileSettingsComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'auth' },
      },
      {
        path: 'manageUser',
        loadComponent: () =>
          import('./components/settings/manage-user/manage-user.component').then(
            (m) => m.ManageUserComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'appAdmin' },
      },
      {
        path: 'syncData',
        loadComponent: () =>
          import('./components/settings/sync-jobs/sync-jobs.component').then(
            (m) => m.SyncJobsComponent,
          ),
        canActivate: [RouteAccessGuard],
        data: { guardMode: 'appAdmin' },
      },
      {
        path: 'callback',
        component: AuthCallback,
      },
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
];
